module.exports = __webpack_public_path__ + "img/iconcoindesk.5535f835.svg";